// extracted by mini-css-extract-plugin
module.exports = {"avatar":"style_avatar__3Mez1","avatarsmall":"style_avatarsmall__26dkY"};